import { Box, ButtonBase, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import moment from "moment-jalaali";
import HTMLParser from "html-react-parser";
import { useState } from "react";
import { useRequest } from "../../api/utils/useRequest";
import { MessagingAPIs } from "../../api/APIs";

const momentFa = moment;
momentFa.locale("fa");
momentFa.loadPersian({ dialect: "persian-modern", usePersianDigits: false });

function MessageCard({ sx = [], ...props }) {
  const { message, setMessages } = props;
  const [open, setOpen] = useState(false);

  const { apiCall: readMessage } = useRequest(MessagingAPIs.readMessage);

  const onReadMessage = () => {
    readMessage({
      data: { id: message.id, state: "READ" },
      onSuccess: () => {
        setMessages((messages) =>
          messages.map((item) => {
            if (item.id === message.id) {
              return {
                ...item,
                state: "READ",
              };
            } else {
              return item;
            }
          })
        );
      },
      onError: () => {},
    });
  };

  return (
    <ButtonBase
      onClick={() => {
        if (message.state === "UNREAD") {
          onReadMessage();
        }
        setOpen((prev) => !prev);
      }}
      sx={{
        width: "100%",
        py: "16px",
        display: "flex",
        alignItems: "flex-start",
        overflow: "hidden",
        borderBottom: (theme) => `1px dotted ${theme.palette.grey[6]}`,
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Typography
          variant="h5"
          color={message.state === "READ" ? "grey.4" : "grey.2"}
        >
          {message.title}
        </Typography>
        <Box
          sx={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: open ? 40 : 3,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <Typography
            mt={1}
            align="left"
            variant="subtitle1"
            color={message.state === "READ" ? "grey.4" : "grey.2"}
          >
            {HTMLParser(
              message.body
                .replace(/(?:\r\n|\r|\n)/g, "<br>")
                .split("<br>")
                .map((item) => {
                  if (item.includes("https:")) {
                    return `<a href="${item}">${item}</a>`;
                  } else {
                    return item;
                  }
                })
                .join("<br>")
            )}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ px: 1, display: "flex", justifyContent: "center" }}>
        <Typography variant="subtitle1" color="grey.4">
          {momentFa(message.publishedTime).fromNow()}
        </Typography>
      </Box>
    </ButtonBase>
  );
}

export default MessageCard;
